import script from "./ProductDetailUpsellItemRecommended.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetailUpsellItemRecommended.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetailUpsellItemRecommended.vue?vue&type=style&index=0&id=423b8952&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423b8952"]])

export default __exports__